import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = " حاسبة الجرعات الدوائية الدقيقة";
const DESCRIPTION =
  "حاسبة الجرعة الدوائية الدقيقة: حدد الكمية اليومية الآمنة من الدواء (ملغ/كغ) بناءً على وزن الجسم والعمر! أداة معتمدة للأطباء والصيادلة مع تفسير للجرعات القصوى والتفاعلات الدوائية المحتملة.";
const KEYWORDS = "الجرعات, حاسبة الجرعات, دواء, وزن المريض";
const OG_URL =
  "https://do-calculate.com/calculator/ar/medicine-dosage-calculator/";
function DosageCalculator() {
  const [totalDosage, setTotalDosage] = useState("");
  const [singleDosage, setSingleDosage] = useState("");
  const [weight, setWeight] = useState("");
  const [frequency, setFrequency] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (weight && totalDosage) {
        let totalDose = parseInt(weight) * parseInt(totalDosage);
        let singleDose = totalDose;
        if (frequency === "مرتين يوميا") {
          singleDose = totalDose / 2;
        } else if (frequency === "ثلاث مرات يوميا") {
          singleDose = totalDose / 3;
        } else if (frequency === "أربع مرات يوميا") {
          singleDose = totalDose / 4;
        } else if (frequency === "كل 4 ساعات") {
          singleDose = totalDose / 6;
        }
        setResult({
          totalDose,
          singleDose: frequency !== "مرة واحدة يوميا" ? singleDose : null,
        });
      }
    } catch (error) {
      setError(error.message);
    }
  };
  const handleFrequencyChange = (selectedFrequency) => {
    setFrequency(selectedFrequency);
    setSingleDosage(selectedFrequency !== "مرة واحدة يوميا");
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  حاسبة جرعات ذكية ودقيقة مصممة خصيصًا لتبسيط عملية حساب الجرعات
                  الدوائية. بفضل واجهتها البديهية، يمكنك بسهولة إدخال وزن المريض
                  والجرعة الموصوفة للحصول على جدول جرعات يومي مفصّل. تعتمد
                  الحاسبة على أحدث المعايير الطبية لضمان دقة النتائج، مما يوفر
                  لك راحة البال والثقة في القرارات التي تتخذها. سواء كنت طبيباً،
                  صيدلياً، أو ولي أمر، فإن هذه الحاسبة هي الأداة المثالية
                  لمساعدتك في إدارة الجرعات الدوائية بفعالية.
                </p>
                <p>لحساب الجرعة اليومية، يمكنك اتباع الخطوات التالية:</p>
                <ul>
                  <li>أدخل وزن المريض</li>
                  <li>أدخل الجرعة الواحدة بالملغرام</li>
                  <li>اختر عدد مرات الجرعة في اليوم</li>
                </ul>
                <p>
                  {" "}
                  تم تطوير الحاسبة بالاعتماد على{" "}
                  <a
                    href="https://lo.unisa.edu.au/pluginfile.php/1902200/mod_resource/content/6/Maths%20for%20Midwifery%20and%20Nursing%20Dosage%20Calculation%20-%20Worksheet_2022.pdf"
                    rel="nofollow"
                  >
                    حساب الجرعة لجامعة جنوب أستراليا - ورقة عمل
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="weight">
                      <label className="form-label ms-2">ادخل الوزن (كغ)</label>
                      <input
                        id="weight"
                        type="number"
                        value={weight}
                        onChange={(e) => setWeight(e.target.value)}
                        placeholder="أدخل الوزن"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="dosage">
                      <label className="form-label ms-2">
                        ادخل الجرعة (mg)
                      </label>
                      <input
                        id="dosage"
                        type="number"
                        value={totalDosage}
                        onChange={(e) => setTotalDosage(e.target.value)}
                        placeholder="أدخل الجرعة"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group items-center">
                      <label className="form-label ms-2" htmlFor="frequency">
                        اختر الجرعة اليومية
                      </label>
                      <select
                        id="frequency"
                        value={frequency}
                        onChange={(e) => handleFrequencyChange(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">اختر الجرعة اليومية</option>
                        <option value="مرة واحدة يوميا">مرة واحدة يوميا</option>
                        <option value="مرتين يوميا">مرتين يوميا</option>
                        <option value="ثلاث مرات يوميا">ثلاث مرات يوميا</option>
                        <option value="أربع مرات يوميا">أربع مرات يوميا</option>
                        <option value="كل 4 ساعات">كل 4 ساعات</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                      disabled={frequency === ""}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>النتيجة:</h4>
                      <p className="text-white">
                        الجرعة اليومية: {result.totalDose} mg
                      </p>
                      {result.singleDose && (
                        <p className="text-white">
                          الجرعة الواحدة: {result.singleDose} mg
                        </p>
                      )}
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">ما هي الجرعة اليومية؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>تعريف الجرعة اليومية</h2>{" "}
                  </u>
                  <p>
                    الجرعة اليومية هي كمية الدواء التي يحتاج المريض لتناولها
                    خلال يوم واحد.
                  </p>
                  <p>
                    تختلف الجرعة اليومية بناءً على وزن المريض وعمره وحالته
                    الصحية.
                  </p>
                  <div className="p-3 mb-2 bg-info">
                    تحديد الجرعة المناسبة هو أمر ضروري لضمان فعالية العلاج.
                  </div>
                  <br />
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>كيف يتم حساب الجرعة؟</h2>{" "}
                  </u>
                  <p>
                    يتم حساب الجرعة باستخدام معادلات طبية تعتمد على وزن المريض
                    والتركيز الدوائي.
                  </p>
                  <ul>
                    <li>معادلة الجرعة الواحدة: وزن المريض × تركيز الدواء</li>
                    <li>معادلة الجرعة اليومية: الجرعة الواحدة × عدد الجرعات</li>
                  </ul>
                  <p>
                    يمكنك استخدام الحاسبة لتحديد الجرعة اليومية بناءً على الوزن
                    والتركيز وعدد مرات الجرعات.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    تأكد دائمًا من اتباع إرشادات الطبيب أو الصيدلي.
                  </div>
                  <hr />
                </div>
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>مثال توضيحي</h2>{" "}
                  </u>
                  <p>لنفترض أنك بحاجة لحساب الجرعة اليومية لدواء معين:</p>
                  <ul>
                    <li>وزن المريض: 70 كغ</li>
                    <li>جرعة الدواء: 10 ملغرام</li>
                    <li>عدد مرات الجرعة اليومية: مرتين</li>
                  </ul>
                  <p>الجرعة اليومية: 70 كغ × 10 ملغرام = 700 ملغرام</p>
                  <p>الجرعة الواحدة: 700 ملغرام / 2 = 350 ملغرام</p>
                  <b>مثال</b>
                  <div className="p-3 mb-2 bg-info text-black">
                    في هذا المثال، الجرعة الواحدة هي 350 ملغرام.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default DosageCalculator;
